 export const QUESTION_TYPES = {
  EXPERIENCE: "Erfahrungsfrage",
  KNOWLEDGE: "Wissensfrage"
}

export function getPrimaryOrganization(self) {
  return self.$store.state.organizations[0];
}